import styled from '@emotion/styled';

interface RadioProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  name: string;
  value: string;
  disabled?: boolean;
  className?: string;
}

const RadioContainer = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(0.5)};
  padding: ${(props) => props.theme.spacing(0.5)};
  border-radius: ${(props) => props.theme.shape.borderRadiusLarge};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: background 0.2s ease;

  &:hover {
    background: ${(props) => (props.disabled ? 'transparent' : props.theme.colors.overlay.hover)};
  }
`;

const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const StyledRadio = styled.div<{ checked: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.checked ? props.theme.colors.primary[1000] : props.theme.colors.neutral.greyDark[800])};
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s ease;

  &::after {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${(props) => props.theme.colors.primary[1000]};
    opacity: ${(props) => (props.checked ? 1 : 0)};
    transition: opacity 0.2s ease;
  }
`;

const Label = styled.span`
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.body3Regular.fontSize};
  font-weight: ${(props) => props.theme.typography.body3Regular.fontWeight};
  color: ${(props) => props.theme.colors.neutral.greyDark[700]};
  line-height: 1.3;
`;

export const Radio = ({ checked, onChange, label, name, value, disabled = false, className }: RadioProps) => {
  return (
    <RadioContainer className={className} disabled={disabled}>
      <HiddenRadio
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <StyledRadio checked={checked} />
      <Label>{label}</Label>
    </RadioContainer>
  );
};
